export const POAStepNames = [
  "IDENTIFY",
  "EMAILANDPHONE",
  "POAINFO",
  "POADURATION",
  "POACONFIRMATION",
  "POASIGN",
  "BOOKMEETING",
  "POASUMMARY",
  "CONFIRMATION",
] as const;
